import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
const SUPER_ADMINS_ENDPOINT = 'permissions-skynet/v1/scopes/app/super-admin/hub-users';
const fetchSuperAdmins = () => http.get(SUPER_ADMINS_ENDPOINT);
export const FETCH_SUPER_ADMINS = registerQuery({
  fieldName: 'accessCheckLibHubSuperAdmins',
  args: [],
  fetcher() {
    return fetchSuperAdmins();
  }
});